import { render } from "./GameCalculator.vue?vue&type=template&id=29fb1c35&scoped=true"
import script from "./GameCalculator.vue?vue&type=script&lang=js"
export * from "./GameCalculator.vue?vue&type=script&lang=js"

import "./GameCalculator.vue?vue&type=style&index=0&id=29fb1c35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fb1c35"]])

export default __exports__